import { useEffect, useState } from "react";
import type { RefObject } from "react";

export function useFloatingActionBar(
  targetRef: RefObject<HTMLElement | null>,
  enabled: boolean
) {
  const [shouldFloat, setShouldFloat] = useState(false);

  useEffect(() => {
    const target = targetRef.current;
    if (!enabled || !target || typeof IntersectionObserver === "undefined") {
      return;
    }

    const root =
      target.closest<HTMLElement>("[data-scroll-container]") ?? null;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShouldFloat(!entry.isIntersecting);
      },
      {
        root,
        rootMargin: "0px 0px -80px 0px",
        threshold: 0,
      }
    );

    observer.observe(target);
    return () => {
      observer.disconnect();
      setShouldFloat(false);
    };
  }, [enabled, targetRef]);

  return enabled && shouldFloat;
}
